/* eslint-disable max-len */
import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { SyncProblemOutlined } from '@mui/icons-material';
import { AlertBoxMsg, Divider } from '@qrios/frontend-library';

import { DialogError } from '../../../business-error';
import locales from '../../../../../constants/locales';
import { DialogActionButtons, DialogDescription } from '../../../dialog';

import { RetriedReport, RetriedReportMetaData } from './interfaces';

interface Props {
  loading: boolean;
  report: RetriedReport | undefined;
  error: DialogError;
  handleRetryReport: () => void;
  handleCloseRetryReport: () => void;
  filtersSummary: (filters: RetriedReportMetaData) => ReactNode;
}

const RetryReportDialog = ({
  loading,
  report,
  error,
  handleRetryReport,
  handleCloseRetryReport,
  filtersSummary
}: Props) => {
  const actions = {
    primary: {
      type: 'button' as const,
      handler: handleRetryReport,
      text: 'Retry report generation'
    },
    secondary: {
      type: 'button' as const,
      handler: handleCloseRetryReport,
      text: locales.button.title.close
    }
  };

  return report ? (
    <Box minHeight="200px" display="flex" flexDirection="column" justifyContent="space-between">
      <DialogDescription icon={SyncProblemOutlined}>
        You want to retry generation of the failed <b>{report.name}</b> report. It will be recreated according to the
        filters below. The failed report will be removed. Click <b>Retry report generation</b> to confirm.
      </DialogDescription>
      <Divider orientation="horizontal" />
      <Box>{filtersSummary(report.metadata)}</Box>
      {error ? (
        <Box pt={2}>
          <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
        </Box>
      ) : null}
      <DialogActionButtons actions={actions} loading={loading} />
    </Box>
  ) : null;
};

export default RetryReportDialog;
